module.exports = __webpack_public_path__ + "static/media/country_iq.04057042.webp";